import { css } from '@genesislcap/web-core';

export const PlatformActivityStyles = css`
  :host {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .platform-activity-main-container {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    background: var(--neutral-layer-1);
  }

  .municipal-bonds-section,
  .bids-section,
  .bid-audit-history-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .municipal-bonds-section h3,
  .bids-section h3,
  .bid-audit-history-section h3 {
    margin: 0 0 0 0;
    font-size: var(--type-ramp-plus-1-font-size);
    font-weight: 600;
    color: var(--neutral-foreground-rest);
  }

  .municipal-bonds-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .filters-container {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  .cusip-filter,
  .reference-filter,
  .issuer-filter,
  .counterparty-filter {
    display: flex;
    gap: 10px;
  }

  .cusip-filter rapid-text-field,
  .reference-filter rapid-text-field,
  .issuer-filter rapid-text-field,
  .counterparty-filter rapid-text-field {
    width: 200px;
    margin-bottom: 0px !important;
  }

  .filters-container rapid-button {
    min-width: 80px;
  }

  .filters-container rapid-button:last-child {
    margin-left: 10px;
  }

  .bids-header,
  .bid-audit-history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .selected-bond-info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--type-ramp-minus-1-font-size);
    color: var(--neutral-foreground-hint);
  }

  mbm-grid-pro {
    flex: 1;
    min-height: 0;
    height: 100%;
  }  

  .filter-label {
    font-size: var(--type-ramp-plus-1-font-size);
    font-weight: 400;
    color: var(--neutral-foreground-rest);
  }

  .filter-buttons {
    display: flex;
  }

`;
